import { useEffect } from 'react';

// Opens Spotlight when the user presses "/", unless it's already open or they're typing
// somewhere else on the page.
type Props = {
	openSpotlight: () => void;
	isEnabled: boolean;
};

export function useSlashKeyShortcut({ openSpotlight, isEnabled }: Props) {
	useEffect(() => {
		if (!isEnabled) {
			return;
		}

		const handleKeyDown = (e: KeyboardEvent) => {
			const target = e.target as HTMLElement;

			if (
				target.tagName === 'INPUT' ||
				target.tagName === 'TEXTAREA' ||
				target.isContentEditable
			) {
				return;
			}

			if (e.key === '/') {
				e.preventDefault();
				openSpotlight();
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [openSpotlight, isEnabled]);
}
